<template>
  <router-link :to="{ path: link }">
    <div class="card-category">
      <div class="card-category-base image">
        <img
          alt="submenu image"
          :src="require(`@/assets/home/${src}`)"
          :style="{
            width: 100 + '%',
            maxHeight: 270 + 'px',
            objectFit: 'cover',
          }"
        />
        <h6 class="card-category-title">{{ title }}</h6>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "CardCategory",
  props: {
    src: String,
    title: String,
    link: String,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.card-category-base {
  position: relative;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.05);
    .card-category-title {
      background-color: $color-primary;
    }
  }
}

.card-category-title {
  color: $color-secondary;
  position: absolute;
  right: 9px;
  bottom: 9px;
  left: 9px;
  width: calc(100% - 18px);
  border-top: 4px solid $color-secondary;
  padding: 5px 15px;
  background-color: $color-gray;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  @media (min-width: $constraint-width-medium) {
    padding: 13px 15px;
  }
}
</style>
